export const iconFontAwesomeEducationLaptopCode = (
	<i className="fa-solid fa-laptop-code"></i>
);
